// Tiny fetch wrapper. All API responses are JSON. On 401, redirect to /login.

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown, message: string) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers || {}),
    },
    ...init,
  });
  const text = await res.text();
  let body: unknown = null;
  if (text) {
    try { body = JSON.parse(text); } catch { body = text; }
  }
  if (!res.ok) {
    if (res.status === 401 && !path.startsWith("/api/auth")) {
      window.location.href = "/login";
    }
    const msg =
      typeof body === "object" && body && "error" in body
        ? String((body as Record<string, unknown>).error)
        : `Request failed with ${res.status}`;
    throw new ApiError(res.status, body, msg);
  }
  return body as T;
}
